import React, { useState, useEffect } from 'react';
import Dialog from './dialogs/Dialog';
import eventEmitter from './utils/eventEmitter';

/**
 * Refresh dialog component
 * @module
 */
const RefreshDialog = () => {
  const [isOpen, setIsOpen] = useState(false);

  const handleOpen = () => {
    setIsOpen(true);
  }

  const handleClose = () => {
    setIsOpen(false);
  }

  const handleConfirm = () => {
    setIsOpen(false);
    window.location.reload(true);
  }

  // componentDidMount
  useEffect(() => {
    eventEmitter.on('ON_UPDATE', handleOpen);
    return () => {
      eventEmitter.removeListener('ON_UPDATE', handleClose);
    }
  }, []);

  return (
    <Dialog
      isOpen={isOpen}
      onClose={handleClose}
      onConfirm={handleConfirm}
      title="Aktualizácia"
      confirmText="Áno"
      cancelText="Nie"
    >
      <p style={{ margin: "15px", textAlign: "center" }}>
        Je dostupná aktualizácia. Prajete si aktualizovať aplikáciu?
      </p>
    </Dialog>
  );

}

RefreshDialog.propTypes = {

}

export default RefreshDialog;